// Get all discount types
export const GET_DISCOUNT_TYPES = "GET_DISCOUNT_TYPES"
export const GET_DISCOUNT_TYPES_SUCCESS = "GET_DISCOUNT_TYPES_SUCCESS"
export const GET_DISCOUNT_TYPES_FAIL = "GET_DISCOUNT_TYPES_FAIL"

// Create discount type
export const CREATE_DISCOUNT_TYPE = "CREATE_DISCOUNT_TYPE"
export const CREATE_DISCOUNT_TYPE_SUCCESS = "CREATE_DISCOUNT_TYPE_SUCCESS"
export const CREATE_DISCOUNT_TYPE_FAIL = "CREATE_DISCOUNT_TYPE_FAIL"

// Clear errors
export const CLEAR_DISCOUNT_TYPE_ERROR = "CLEAR_DISCOUNT_TYPE_ERROR"
